import React, { useState } from "react";
import { Button, Icon, Modal, TransitionablePortal } from "semantic-ui-react";
import "./ProfileEvents.css";
import "../components/athletes/AthleteCoachList.css";
import { connect, useDispatch } from "react-redux";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";
import "react-datepicker/dist/react-datepicker.css";
import AddEvent from "./AddEvent";
import EventCard from "../components/layout/EventCard";
import { deleteEventDoc } from "../store/actions/athleteActions";
import EditEvent from "./EditEvent";

const ProfileEvents = (props) => {
  const [addEvent, setAddEvent] = useState(false);
  const [deleteEvent, setDeleteEvent] = useState(false);
  const [deleteEventId, setDeleteEventId] = useState(null);
  const [editEvent, setEditEvent] = useState(false);
  const [id, setId] = useState(null);
  const [name, setName] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [url, setUrl] = useState(null);
  const [advocate, setAdvocate] = useState(null);
  const [location, setLocation] = useState(null);
  const [sport, setSport] = useState(null);
  const [creator, setCreator] = useState(null);
  const [attenders, setAttenders] = useState(null);
  const [status, setStatus] = useState(null);
  const dispatch = useDispatch();
  const handleAddEventModal = () => {
    setAddEvent(!addEvent);
  };
  const handleAddEventClose = () => {
    setAddEvent(false);
  };
  const handleEditEventClose = () => {
    setEditEvent(false);
  };
  const handleEditEventOpen = (
    id,
    name,
    startDate,
    endDate,
    url,
    advocate,
    location,
    sport,
    creator,
    attenders,
    status
  ) => {
    setEditEvent(true);
    setId(id);
    setName(name);
    setStartDate(startDate);
    setEndDate(endDate);
    setUrl(url);
    setAdvocate(advocate);
    setLocation(location);
    setSport(sport);
    setCreator(creator);
    setAttenders(attenders);
    setStatus(status);
  };
  const handleDelteEventModal = (id) => {
    setDeleteEventId(id);
    setDeleteEvent(!deleteEvent);
  };
  const handleDelteEventClose = () => {
    setDeleteEvent(false);
  };
  const handleDeleteEvent = () => {
    dispatch(deleteEventDoc(deleteEventId));
    setDeleteEvent(false);
  };
  const animation = "scale";
  const duration = 500;
  return (
    <div className="AthleteDetailsBackground cu-profile">
      <div className="AthleteDetailsBannerBar"></div>
      <div className="AthleteSearchBanner">
        <h1>Events</h1>
      </div>
      <div className="AthleteDetailsButtonContainer event-header">
        <div className="first-div"></div>
        <div className="second-div">
          <Button
            icon
            labelPosition="green"
            color="blue"
            onClick={handleAddEventModal}
          >
            <Icon name="calendar plus outline" />
            Add Event
          </Button>
        </div>
      </div>
      <div className="AthleteEventsInfoContainer common-event">
        {props.events && props.events.length < 1 && (
          <p className="not-found cu-center">There's No Data Right Now</p>
        )}
        <div
          className={`AthleteEventsGroupContainer ${
            props.events &&
            (props.events.length === 1
              ? "onlyone"
              : props.events.length === 2
              ? "onlytwo"
              : "")
          }`}
        >
          {/* if(1) = onlyone
          if(1) = onlytwo */}
          {/*  */}
          {props.events &&
            props.events.map((event) => (
              <>
                <EventCard
                  eyShow={false}
                  id={event.eventId}
                  name={event.eventName}
                  startDate={
                    typeof event.eventStartDate !== "string"
                      ? event.eventStartDate.toDate().toDateString()
                      : event.eventStartDate
                  }
                  endDate={
                    typeof event.eventEndDate !== "string"
                      ? event.eventEndDate.toDate().toDateString()
                      : event.eventEndDate
                  }
                  url={event.eventUrl}
                  advocate={event.eventAdvocate}
                  location={event.eventLocation}
                  creator={event.eventCreator}
                  attendant={event.attenders}
                  status={event.eventStatus}
                  sport={event.eventSport}
                  visitors={event.eventAttenders}
                  deleteEvent={(id) => handleDelteEventModal(id)}
                  editEvent={() =>
                    handleEditEventOpen(
                      event.eventId,
                      event.eventName,
                      typeof event.eventStartDate !== "string"
                        ? event.eventStartDate.toDate().toDateString()
                        : event.eventStartDate,
                      typeof event.eventEndDate !== "string"
                        ? event.eventEndDate.toDate().toDateString()
                        : event.eventEndDate,
                      event.eventUrl,
                      event.eventAdvocate,
                      event.eventLocation,
                      event.eventSport,
                      event.eventCreator,
                      event.eventAttenders,
                      event.eventStatus
                    )
                  }
                />
              </>
            ))}
        </div>
      </div>

      <TransitionablePortal
        transition={{ animation, duration }}
        open={deleteEvent}
        onClose={handleDelteEventClose}
      >
        <Modal
          className="delete-popup"
          onClose={handleDelteEventClose}
          open={true}
        >
          <Modal.Content>
            <p className="p1">Are you sure want to delete this record?</p>
            <p className="p2">This process cannot be undone.</p>
            <div className="delete-modal-footer">
              <Button
                name="closeButton"
                content="Cancel"
                onClick={handleDelteEventClose}
              />
              <Button
                color="red"
                name="saveButton"
                content="Delete"
                onClick={handleDeleteEvent}
              />
            </div>
          </Modal.Content>
        </Modal>
      </TransitionablePortal>
      <AddEvent
        open={addEvent}
        role={props.role && props.role}
        close={handleAddEventClose}
      />
      <EditEvent
        open={editEvent}
        role={props.role && props.role}
        close={handleEditEventClose}
        id={id}
        name={name}
        startDate={startDate}
        endDate={endDate}
        url={url}
        advocate={advocate}
        location={location}
        creator={creator}
        attenders={attenders}
        sport={sport}
        status={status}
      />
    </div>
  );
};

const mapStateToProps = (state, ownProps) => {
  let advocate;
  let uid;
  let role;
  let advocateKey;
  let events;
  if (
    state.firebase.auth &&
    state.firestore.data.userRole &&
    state.firestore.data.advocates
  ) {
    uid = state.firebase.auth.uid;
    const keys = Object.keys(state.firestore.data.userRole);
    keys.forEach((key) => {
      if (state.firestore.data.userRole[key].userUID === uid) {
        role = state.firestore.data.userRole[key].role;
        advocateKey = state.firestore.data.advocates[key].id;
        advocate = state.firestore.data.advocates[key];
      }
    });
  }
  if (
    state.firebase.auth &&
    state.firestore.data.events &&
    state.firestore.data.athletes &&
    state.firestore.data.advocates
  ) {
    const keys = Object.keys(state.firestore.data.events);
    const rawEvents = keys.map((key) => {
      if (
        state.firestore.data.events[key] &&
        (state.firestore.data.events[key].eventCreator === uid ||
          state.firestore.data.events[key].eventAttenders.includes(uid))
      ) {
        let event = state.firestore.data.events[key];
        if (event) {
          let attenders = event.eventAttenders;
          attenders = attenders.map((visitor) => {
            const person = {};
            if (visitor in state.firestore.data.athletes) {
              person.name =
                state.firestore.data.athletes[visitor].firstName +
                " " +
                state.firestore.data.athletes[visitor].lastName;
              person.image = state.firestore.data.athletes[visitor].thumbnail;
              person.id = visitor;
              person.customUrl =
                state.firestore.data.athletes[visitor].customUrl;
              person.extraData = state.firestore.data.athletes[visitor];
            } else if (visitor in state.firestore.data.advocates) {
              person.name = state.firestore.data.advocates[visitor].name;
              person.image =
                state.firestore.data.advocates[visitor].thumbnailUrl;
              person.id = visitor;
              person.customUrl =
                state.firestore.data.advocates[visitor].customUrl;
            }
            return person;
          });
          return { ...event, attenders };
        }
      }
    });
    events = rawEvents.filter((event) => event);
    events = events.sort(
      (date1, date2) => date2.eventStartDate - date1.eventStartDate
    );
  }

  return {
    uid,
    advocateKey,
    role,
    advocate,
    events: events ? events.filter((event) => event) : [],
  };
};

export default compose(
  connect(mapStateToProps),
  firestoreConnect(() => [
    {
      collection: "advocates",
    },
    {
      collection: "userRole",
    },
    {
      collection: "events",
    },
    {
      collection: "adminAthletes",
      storeAs: "athletes",
    },
  ])
)(ProfileEvents);
